import React, { type PropsWithChildren } from 'react';

export type AhaCardWCResolverProps = {
  'highlight-color'?: string;
  'use-background-color'?: boolean;
  shadow?: boolean;
  style?: React.CSSProperties;
  class?: string;
  selected?: boolean;
};

const AhaCardWCResolver: React.FC<
  PropsWithChildren<AhaCardWCResolverProps>
> = ({ children, ...props }) => <aha-card {...props}>{children}</aha-card>;

export default AhaCardWCResolver;
